































































































































































































































































// Keep this Storybook integration import at component level.
import i18n from 'vue-i18n';

import axios from 'axios';
import { get, uniq, uniqBy, upperFirst, toLower } from 'lodash';
import { format, addHours } from 'date-fns';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoPeople from '@/components/Molecules/co-people/CoPeople.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoContentSection from '@/components/Organisms/сo-content-section/CoContentSection.vue';
import CoShare from '@/components/Organisms/co-share/CoShare.vue';
import { google, outlook, ics } from 'calendar-link';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';

export default {
    name: 'PublicEventView',
    i18n: {
        messages: {
            en: {
                labels: {
                    updateEvent: 'Update Event Details',
                    drafteventheadline: 'This event is in a draft mode',
                    eventVisability: 'Event Visability Settings',
                    publiceventheadline: 'This event is public and visible to everyone',
                    communityeventheadline: 'This event is visible to community members only',
                    draft: 'Draft',
                    public: 'Public',
                    communityOnly: 'Community Only',
                    closePreviewAsMember: 'Close Preview',
                    previewAsMember: 'Preview as Member',
                    addsection: 'Add Section',
                    textSection: 'Text Section',
                    imageSection: 'Image Section',
                    cancelattendance: 'Cancel attendance',
                    getticket: 'Get Ticket',
                    google: 'Google',
                    outlook: 'Outlook',
                    ics: 'ICS',
                    dragdropimage: 'Drag and drop an image here or click to upload',
                    suggestedsizes: 'Suggested size 1280x720px (16:9)',
                    savetocalendar: 'save to calendar',
                },

                messages: {
                    cancelmessage: 'Are you sure about this? This event would be much nicer with you!',
                    makePublic: 'Event will be visible to everyone outside the community. Are you sure?',
                    communityOnly: 'Event will be visible only to community members. Are you sure?',
                    deleteImageHeaderWarning: 'Are you sure you want to delete the header image?',
                    draftEvent: 'Event will be saved as a draft making it hidden. Are you sure?',
                    vieweventdetailsincommunity: 'View event',
                },
            },
            de: {
                labels: {
                    updateEvent: 'Veranstaltungsdetails aktualisieren',
                    drafteventheadline: 'Dieses Event ist im Entwurfsmodus',
                    eventVisability: 'Veranstaltungssichtbarkeitseinstellungen',
                    publiceventheadline: 'Dieses Event ist öffentlich und für alle sichtbar',
                    communityeventheadline: 'Dieses Event ist nur für Community-Mitglieder sichtbar',
                    draft: 'Entwurf',
                    public: 'Öffentlich',
                    communityOnly: 'Nur für die Community',
                    closePreviewAsMember: 'Vorschau schließen',
                    previewAsMember: 'Vorschau als Mitglied',
                    addsection: 'Abschnitt hinzufügen',
                    textSection: 'Textabschnitt',
                    imageSection: 'Bildabschnitt',
                    cancelattendance: 'Teilnahme absagen',
                    getticket: 'Tickets',
                    dragdropimage: 'Ziehen Sie ein Bild hierher oder klicken Sie hier, um es hochzuladen',
                    suggestedsizes: 'Empfohlene Größe 1280x720px (16:9)',
                    savetocalendar: 'im Kalender speichern',
                },

                messages: {
                    cancelmessage:
                        'Bist du dir sicher, dass du das willst? Diese @:labels.event wäre viel schöner mit dir!',
                    makePublic: 'Die Veranstaltung wird für alle außerhalb der Community sichtbar. Bist du sicher?',
                    communityOnly: 'Die Veranstaltung wird nur für Community-Mitglieder sichtbar. Bist du sicher?',
                    deleteImageHeaderWarning: 'Möchten Sie das Titelbild wirklich löschen?',
                    draftEvent: 'Die Veranstaltung wird als Entwurf gespeichert und versteckt. Bist du sicher?',
                    vieweventdetailsincommunity: 'Veranstaltung anzeigen',
                },
            },
        },
    },
    components: {
        CoIcon,
        CoImage,
        CoText,
        CoButton,
        CoHeadline,
        CoDate,
        CoPill,
        CoCard,
        CoPeople,
        CoLink,
        CoSkeleton,
        CoDropdown,
        CoDropdownItem,
        CoContentSection,
        CoShare,
        CoUser,
    },
    props: {
        slug: {
            type: String,
            required: false,
            default: 'test',
        },
        me: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    data() {
        return {
            event: {},
            createdBy: {},
            preview: false,

            todayDate: new Date().toISOString().split('T')[0],
            startDate: '',
            startTime: '',

            endDate: '',
            endTime: '',

            loadingParticipants: false,
            participants: [],
            organizers: [],

            sectionsRerenderKey: 0,
            loadingEvent: false,

            taxRates: [],
            loadingTaxRates: false,
        };
    },
    watch: {
        startDate(val) {
            // if end date is before start date, set end date to start date

            // convert to timestamp
            const start = new Date(val);
            const end = new Date(this.endDate);

            if (end < start) {
                this.endDate = val;
            }
        },

        startTime() {
            // if end time is before start time, set end time to start time
            // compose start date and time
            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);
            // convert to timestamp

            if (end <= start) {
                const tmp = addHours(start, 1);
                this.endTime = format(tmp, 'HH:mm');
            }
        },
    },
    computed: {
        // useTicketCheckout check if there any active ticket in event
        useTicketCheckout() {
            const tickets = get(this.event, 'Tickets', []);
            const activeTicket = tickets.find((item) => !item.Deleted);
            return !!activeTicket;
        },
        noContent() // if no sections and no image and no tags return true
        {
            return (
                (!this.event.Sections || this.event.Sections.length === 0) &&
                !this.event.ImageURL &&
                (!this.event.Tags || this.event.Tags.length === 0)
            );
        },
        eventurl() {
            return `${window.location.origin}/events/${this.event.Slug}`;
        },
        isEventPast() {
            return this.event.EndDate < new Date().getTime() / 1000;
        },
        allParticipants() {
            const p = get(this.event, 'Participants', []);
            const o = get(this.event, 'Organizers', []);
            // concat participants and organizers and remove duplicates
            let res = [...p, ...o];
            // add createdBy
            res = res.concat(this.event.CreatedBy);

            return uniq(res);
        },
        isSameDay() {
            const start = new Date(this.event.StartDate * 1000);
            const end = new Date(this.event.EndDate * 1000);
            return start.toDateString() === end.toDateString();
        },
        loactionWithNewLine() {
            if (!this.event || !this.event.Location) {
                return '';
            }
            return this.event.Location.replaceAll(', ', '<br/>');
        },
    },
    created() {
        this.getEvent();
        this.getTaxRates();
    },

    methods: {
        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/space/tax/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    // eslint-disable-next-line no-console
                    console.log(error);
                });
        },

        gotoLogin() {
            this.$router.push(`/login?redirect=${this.$route.fullPath.replace('/public', '')}`);
        },
        addToCalendar(cal = 'google') {
            const calendarEvent = {
                richText: {
                    title: this.event.Title,
                    location: this.event.Location ? this.event.Location : null,
                    description: this.convertToPlain(this.event.Description),
                    start: new Date(this.event.StartDate * 1000).toISOString(),
                    end: new Date(this.event.EndDate * 1000).toISOString(),
                },
                plainText: {
                    title: this.event.Title,
                    location: this.event.Location ? this.event.Location : null,
                    description: this.convertToPlain(this.event.Description),
                    start: new Date(this.event.StartDate * 1000).toISOString(),
                    end: new Date(this.event.EndDate * 1000).toISOString(),
                },
            };
            // add event url to the description
            if (this.eventurl) {
                calendarEvent.richText.description += `<hr />🔗 <a href="${this.eventurl}" target="_blank">${this.$t(
                    'messages.vieweventdetailsincommunity'
                )}</a>`;
                calendarEvent.plainText.description += `
                ----------------
                🔗 ${this.$t('messages.vieweventdetailsincommunity')}: ${this.eventurl}`;
            }
            // Then fetch the link
            if (cal === 'google') {
                const calendarUrl = google(calendarEvent.richText);
                if (this.$store?.state?.isInMobile) {
                    this.openCalendarInBrowser(calendarUrl);
                    return;
                }
                window.open(calendarUrl, '_blank');
            } else if (cal === 'outlook') {
                const calendarUrl = outlook(calendarEvent.richText);
                if (this.$store?.state?.isInMobile) {
                    this.openCalendarInBrowser(calendarUrl);
                    return;
                }
                window.open(calendarUrl, '_blank');
            } else if (cal === 'ics') {
                this.downloadIcsFile(calendarEvent.plainText);
            }
        },
        openCalendarInBrowser(calendarUrl) {
            // The native app observes this query parameter and opens the external URL in the device browser.
            this.$router.push({
                query: {
                    ...this.$route.query,
                    m: 'mobile',
                    openinbrowser: calendarUrl,
                    t: new Date().getTime(),
                },
            });
        },
        downloadIcsFile(calendarEvent) {
            // Download a real calendar file because browsers block top-level navigation to data URLs.
            const calendarDataUrl = ics(calendarEvent);
            const calendarContent = decodeURIComponent(calendarDataUrl.slice(calendarDataUrl.indexOf(',') + 1));
            const objectUrl = window.URL.createObjectURL(
                new Blob([calendarContent], { type: 'text/calendar;charset=utf-8' })
            );
            const link = document.createElement('a');
            link.href = objectUrl;
            link.setAttribute('download', `${this.event.Slug || 'event'}.ics`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
        },
        convertToPlain(html) {
            if (!html || typeof html !== 'string') {
                return '';
            }
            const tempDivElement = document.createElement('div');
            tempDivElement.innerHTML = html;
            return tempDivElement.textContent.trim() || tempDivElement.innerText.trim() || '';
        },
        openTicketURL() {
            window.open(this.event.FullURL, '_blank');
        },
        parseEventDates() {
            const start = new Date(this.event.StartDate * 1000);
            [this.startDate] = start.toISOString().split('T');
            this.startTime = format(start, 'HH:mm');

            const end = new Date(this.event.EndDate * 1000);
            [this.endDate] = end.toISOString().split('T');
            this.endTime = format(end, 'HH:mm');
        },
        get,
        upperFirst,
        toLower,
        async getEvent() {
            this.loadingEvent = true;
            try {
                const response = await axios.get(`/public/event/${this.slug}`);
                this.event = response.data;

                if (get(this.event, 'Sections', []).length === 0 && this.event.Description) {
                    this.event.Sections = [
                        {
                            Type: 0,
                            Content: this.event.Description,
                        },
                    ];
                }

                this.organizers = get(this.event, 'Organizers', []);
                this.participants = get(this.event, 'Participants', []);

                // unify participants names
                this.organizers = this.organizers.map((p) => ({
                    ...p,
                    Name: `${p.FistName} ${p.LastName}`,
                    Role: 'organizer',
                }));

                // unify participants names
                this.participants = this.participants.map((p) => ({
                    ...p,
                    Name: `${p.FistName} ${p.LastName}`,
                    Role: 'participant',
                }));

                // combine participants and organizers
                this.participants = uniqBy([...this.organizers, ...this.participants], 'LastName');

                this.parseEventDates();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
                if (error.message.includes('404') || error.message.includes('403')) {
                    this.gotoLogin();
                }
            }
            this.loadingEvent = false;
        },
    },
};
